import { render, staticRenderFns } from "./ForumConfig.vue?vue&type=template&id=02208cd3&"
import script from "./ForumConfig.vue?vue&type=script&lang=js&"
export * from "./ForumConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports